import { render, staticRenderFns } from "./prod_s.vue?vue&type=template&id=4b4dd364&scoped=true&"
import script from "./prod_s.vue?vue&type=script&lang=js&"
export * from "./prod_s.vue?vue&type=script&lang=js&"
import style0 from "./prod_s.vue?vue&type=style&index=0&id=4b4dd364&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4dd364",
  null
  
)

export default component.exports